/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-16, 11:18:39
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-27, 12:08:24
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

/** All routes configurations */

export default [
  { path: '/',
    name: 'DecodeToken',
    component: () => import('@/views/DecodeTokenPage'),
    props: route => ({ token: route.query.token }),
    children: [
      {
        path: '/pay',
        name: 'pay',
        component: () => import('@/views/PaymentPayPage'),
      },
      {
        path: '/error',
        name: 'error',
        component: () => import('@/views/PaymentErrorPage'),
      },
      {
        path: '/info',
        name: 'info',
        component: () => import('@/views/PaymentInfoPage'),
      },
    ],
  },
  {
    path: '/after',
    name: 'AfterPaymentPage',
    component: () => import('@/views/AfterPaymentPage'),
    props: route => ({
      salesServicePointRedirectUrl: route.query.redirect || null,
      hasError: !!route.query.error,
      lang: route.query.lang || 'pl',
    }),
  },
  // catch all other redirect
  { path: '*', redirect: '/error' },
];



// WEBPACK FOOTER //
// ./src/router/routes.js